import { render, staticRenderFns } from "./EditDatasetDialog.vue?vue&type=template&id=f6580eda"
import script from "./EditDatasetDialog.vue?vue&type=script&lang=js"
export * from "./EditDatasetDialog.vue?vue&type=script&lang=js"
import style0 from "./EditDatasetDialog.vue?vue&type=style&index=0&id=f6580eda&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports